import React, { useState, useEffect } from "react";

import * as R from "ramda";

import { Loading } from "src/components";
import { BoxWithKeyboardPadding } from "src/banking/components";

import sdk from "src/sdk";

import { DynamicForm } from "src/components/Form";

const buildKey = keyName =>
  R.pipe(
    R.toString,
    R.concat(`${keyName}`)
  );

const questionKey = buildKey("challengeQuestions");
const answerKey = buildKey("challengeAnswers");

const getAvailableQuestions = ({
  index,
  values,
  challengeQuestionsRequired,
  allOptions,
}) => {
  const usedQuestions = R.pipe(
    vals =>
      R.times(questionIndex => {
        const question =
          index === questionIndex
            ? undefined
            : vals[questionKey(questionIndex)];
        return question;
      }, challengeQuestionsRequired),
    R.reject(R.isNil)
  )(values);

  const availableQuestions = R.reject(option => {
    return R.contains(option.value, usedQuestions);
  }, allOptions);

  return availableQuestions;
};

const buildChallengeQuestionField = ({
  challengeQuestionsRequired,
  questionOptions,
}) => index => props => {
  const availableOptions = getAvailableQuestions({
    index,
    values: props.values,
    challengeQuestionsRequired: challengeQuestionsRequired,
    allOptions: questionOptions,
  });

  return {
    type: "section",
    style: {
      mb: 3,
    },
    fields: [
      {
        key: questionKey(index),
        label: `Question #${index + 1}`,
        required: true,
        type: "dropdown",
        inputProps: {
          wrap: true,
          options: availableOptions,
        },
      },
      {
        key: answerKey(index),
        label: "Answer",
        required: true,
        inputProps: {
          autoComplete: "off",
        },
      },
    ],
  };
};

const fields = ({ questionOptions, challengeQuestionsRequired }) => ({
  t,
  values,
  ...others
}) => {
  return [
    {
      type: "section",
      title: "New Security Questions",
      fields: R.pipe(
        R.times(
          buildChallengeQuestionField({
            challengeQuestionsRequired,
            questionOptions,
          })
        ),
        R.flatten
      )(challengeQuestionsRequired),
    },
  ];
};

const buildQuestionOption = question => ({
  value: question.challengeId,
  label: question.challengeQuestion,
});

const getChallengeAnswers = data => index => ({
  Challenge_ID: parseInt(R.prop(questionKey(index), data), 10),
  Answer: R.prop(answerKey(index), data),
});

const ResetQuestions = ({
  onSubmit,
  challengeQuestionsRequired = 3,
  ...props
}) => {
  const [questionOptions, setQuestionOptions] = useState();

  useEffect(() => {
    const getOptions = async () => {
      const challengeQuestions = await sdk.getChallengeQuestions();

      setQuestionOptions(R.map(buildQuestionOption, challengeQuestions));
    };

    getOptions();
  }, []);

  const handleSubmit = (values, formikProps) => {
    const challengeAnswers = R.times(
      getChallengeAnswers(values),
      challengeQuestionsRequired
    );

    return onSubmit(
      {
        NewChallenges: challengeAnswers,
      },
      formikProps
    );
  };

  return questionOptions ? (
    <BoxWithKeyboardPadding>
      <DynamicForm
        formKey="enrollment"
        fields={fields({ questionOptions, challengeQuestionsRequired })}
        needsCaptcha={false}
        onSubmit={handleSubmit}
        {...props}
      />
    </BoxWithKeyboardPadding>
  ) : (
    <Loading />
  );
};

export default ResetQuestions;



// WEBPACK FOOTER //
// ./src/banking/authentication/ForgotFlow/ForgotChallengeQuestions/steps/ResetQuestions.js